import React from "react";
import { Avatar } from "@mui/material";
import { getAvatarPath } from "../../utils";
import { Folder as IconFolder } from "@mui/icons-material";
import { getFolderIcon } from "../../utils/icons";

function AssetFolderAvatar({ assetFolder, size = "1.25rem" }) {
  if (assetFolder?.style?.icon?.name === "image") {
    if (getAvatarPath(assetFolder?.avatar)) {
      return <Avatar variant="rounded" size={size} src={getAvatarPath(assetFolder?.avatar)}></Avatar>;
    }
    return (
      <Avatar>
        <IconFolder></IconFolder>
      </Avatar>
    );
  }

  const IconComponent = getFolderIcon(assetFolder?.style?.icon?.name);
  return IconComponent ? (
    <IconComponent
      style={{
        width: size,
        height: size,
      }}
      color="#ffffff"
    />
  ) : null;
}

export default AssetFolderAvatar;
